import { useTheme } from '@emotion/react';
import { Box, Stack, TablePagination, Typography } from '@mui/material';
import { CancelToken } from 'apisauce';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PageHeader from '../../../components/PageHeader';
import OverviewList from './Components/OverviewList';
import Voyage from './Voyage';
import { useTranslation } from 'react-i18next';
import { checkPermission } from '../../../redux/features/authSlice';
import AccessDenied from '../AccesDenied/AccessDenied';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Stack
          flex={1}
          sx={{ p: 0 }}
        >
          {children}
        </Stack>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const contactsTypes = [
  {
    title: 'Ship owner',
    type: 'ship owner',
  },
  {
    title: 'Ship manager',
    type: 'ship manager',
  },
  {
    title: 'Operator',
    type: 'operator',
  },
  {
    title: 'Charterer',
    type: 'charterer',
  },
];

export default function Overview() {
  const { user } = useSelector((state) => state.auth);

  const [tabIndexValue, setTabIndexValue] = React.useState(0);
  const [filter, setFilter] = React.useState('');
  const [contacts, setContacts] = React.useState([]);
  const [selectedContact, setSelectedContact] = React.useState(null);

  const monitorPermission = useSelector((state) => checkPermission(state, 'Dashboard', 'Monitor Dashboard'));

  const {t} = useTranslation()

  const handleChange = (event, newValue) => {
    setTabIndexValue(newValue);
    setFilter('');
  };

  const handleSearchEmit = (search) => {
    setFilter(search);
  };

  const selectRow = (type, contact) => {
    setSelectedContact({ type, contact });
  };

  useEffect(() => {
    if (user) {
      setContacts(contactsTypes);
    }
  }, [user?.companyType]); 

  return (
   monitorPermission.viewAccess ? <React.Fragment>
      <Stack
        sx={{ display: Boolean(selectedContact) ? 'none' : 'flex' }}
        flex={1}
        className="m-[8px] rounded-[8px] bg-white"
      >
        <PageHeader
          tableType={'2'}
          handleFilterButton={true}
          handleOnSearchEmit={(search) => {
            handleSearchEmit(search);
          }}
          searchValue={filter}
          useSearchValue={true}
        >
          <Tabs
            TabIndicatorProps={{
              style: {
                backgroundColor: '#FFCC00',
              },
            }}
            value={tabIndexValue}
            onChange={handleChange}
          >
            {contacts.map((item, index) => (
              <Tab
                key={index}
                className="!capitalize  !text-[#14285A]	"
                label={t(item.title)}
                {...a11yProps(index)}
              />
            ))}
          </Tabs>
        </PageHeader>
        {contacts.map((item, index) =>
          tabIndexValue === index ? (
            <TabPanel
              className="flex flex-col flex-1"
              value={tabIndexValue}
              index={index}
            >
              <OverviewList
                filter={filter}
                type={item.type}
                onClickRow={(contact, index) => {
                  selectRow(item.type, contact);
                }}
              />
            </TabPanel>
          ) : null,
        )}
      </Stack>
      {Boolean(selectedContact) && (
        <Stack
          flex={1}
          direction="row"
          className="m-[8px] rounded-[8px] bg-white"
        >
          <Voyage
            data={selectedContact}
            onBack={() => {
              setSelectedContact(null);
            }}
          />
        </Stack>
      )}
    </React.Fragment>: <AccessDenied />
  );
}
